import { render, staticRenderFns } from "./AuthorizationCodeCmp.vue?vue&type=template&id=fd40ce16&scoped=true"
import script from "./AuthorizationCodeCmp.vue?vue&type=script&lang=js"
export * from "./AuthorizationCodeCmp.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationCodeCmp.vue?vue&type=style&index=0&id=fd40ce16&lang=css"
import style1 from "./AuthorizationCodeCmp.vue?vue&type=style&index=1&id=fd40ce16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd40ce16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd40ce16')) {
      api.createRecord('fd40ce16', component.options)
    } else {
      api.reload('fd40ce16', component.options)
    }
    module.hot.accept("./AuthorizationCodeCmp.vue?vue&type=template&id=fd40ce16&scoped=true", function () {
      api.rerender('fd40ce16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/AuthorizationCodeCmp.vue"
export default component.exports